import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Accordion } from 'Components/frameworks/accordion/Accordion';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
import type { TabsItem } from 'Components/frameworks/tabs/Tabs';
type Props = {
  areAllCollapsable?: boolean;
  areMultiExpandable?: boolean;
  initialSelectedItems?: Array<number>;
  items: Array<TabsItem>;
  [key: string]: unknown;
};
export const ResponsiveTabs = ({
  areAllCollapsable,
  areMultiExpandable,
  initialSelectedItems = [],
  ...rest
}: Props) => {
  const { isTablet } = useResponsive();
  return isTablet ? (
    <Tabs {...rest} initialSelectedItem={initialSelectedItems[0]} />
  ) : (
    <Accordion
      {...rest}
      areAllCollapsable={areAllCollapsable}
      areMultiExpandable={areMultiExpandable}
      initialSelectedItems={initialSelectedItems}
    />
  );
};
